import { render, staticRenderFns } from "./PaymentBankTransfer.vue?vue&type=template&id=6c733987&"
import script from "./PaymentBankTransfer.vue?vue&type=script&lang=js&"
export * from "./PaymentBankTransfer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports